import { EmailTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/email-type.enum";

export const EMAIL_TYPE_OPTIONS = [
  { value: EmailTypeEnum.PRINCIPAL, label: 'Principal' },
  { value: EmailTypeEnum.ATENCION_CLIENTE, label: 'Atención al cliente' },
  { value: EmailTypeEnum.VENTAS, label: 'Ventas' },
  { value: EmailTypeEnum.FACTURACIÓN, label: 'Facturación' },
];